/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
/* eslint-disable new-cap */
import { brand } from '../../theme/themePrimitives';
import CustomDropdown from '../reusable/dropdown';
import { styled } from '@mui/material/styles';
import { toast } from 'react-toastify';
import { useParams } from 'react-router';
import { activeInactiveDayThunk, removeTimeThunk, updateTimeThunk } from '../../redux/thunks/calendar';
import { AppDispatch, RootState } from '../../redux/store';
import { AvailabilityHoursObject, UpdateHoursParams, WeeklyDayObject } from '../../params/redux/calendar';
import { Box, Button, Grid, IconButton, Switch, Typography } from '@mui/material';
import { ContentCopy, Delete } from '@mui/icons-material';
import { convertTo24Hour, getFilteredEndTimeOptions, getFilteredStartTimeOptions } from '../../helper/time_conflict';
import { useDispatch, useSelector } from 'react-redux';

const IOSSwitch = styled(Switch)(({ theme }) => ({
    'width': 42,
    'height': 26,
    'padding': 0,
    '& .MuiSwitch-switchBase': {
        'padding': 0,
        'margin': 2,
        'transitionDuration': '300ms',
        '&.Mui-checked': {
            'transform': 'translateX(16px)',
            'color': '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: brand[300],
                opacity: 1,
                border: 0
            }
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.5
        }
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 22,
        height: 22
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: '#E9E9EA',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500
        })
    }
}));

const WeeklyHoursComponent = () => {
    const { id } = useParams();
    const dispatch = useDispatch<AppDispatch>();
    const { currentUser } = useSelector((state: RootState) => state.app);
    const { selectedCustomer } = useSelector((state: RootState) => state.customer);
    const { slots } = useSelector((state: RootState) => state.calendar);

    const handleToggle = async (day: WeeklyDayObject) => {
        try {
            let user_id = 0;
            if (id && currentUser?.role !== 'client') {
                user_id = selectedCustomer?.id || 0;
            } else {
                user_id = currentUser?.id as number;
            }
            await dispatch(activeInactiveDayThunk({
                user_id,
                day_id: day.id,
                status: day.status === 'active' ? 'inactive' : 'active'
            })).unwrap();
        } catch (e) {
            //
        }
    };

    const handleTimeChange = async (
        day_id: number,
        hour: AvailabilityHoursObject,
        by: 'to' | 'from',
        value: string
    ) => {
        try {
            const start = by === 'from' ? value : hour.start_time;
            const end = by === 'to' ? value : hour.end_time;
            if (start && end) {
                const startMins = convertTo24Hour(start);
                const endMins = convertTo24Hour(end);

                if (startMins >= endMins) {
                    toast.error('Start time must be before end time', {
                        position: 'top-left',
                        theme: 'dark'
                    });
                    return;
                }

                if (endMins <= startMins) {
                    toast.error('End time must be after start time', {
                        position: 'top-left',
                        theme: 'dark'
                    });
                    return;
                }
            }
            let user_id = 0;
            if (id && currentUser?.role !== 'client') {
                user_id = selectedCustomer?.id || 0;
            } else {
                user_id = currentUser?.id as number;
            }
            const data: UpdateHoursParams = {
                user_id,
                availability_day_id: day_id,
                start_time: by === 'from' ? value : hour.start_time || '',
                end_time: by === 'to' ? value : hour.end_time || '',
                availability_hours_id: hour.id
            };
            await dispatch(updateTimeThunk(data)).unwrap();
        } catch (e) {
            //
        }
    };

    const addTimeBlock = async (day: number) => {
        try {
            let user_id = 0;
            if (id && currentUser?.role !== 'client') {
                user_id = selectedCustomer?.id || 0;
            } else {
                user_id = currentUser?.id as number;
            }
            const data: UpdateHoursParams = {
                user_id,
                availability_day_id: day,
                start_time: '',
                end_time: '',
                availability_hours_id: null
            };
            await dispatch(updateTimeThunk(data)).unwrap();
        } catch (e) {
            //
        }
    };

    const removeTimeBlock = async (hour_id: number) => {
        try {
            let user_id = 0;
            if (id && currentUser?.role !== 'client') {
                user_id = selectedCustomer?.id || 0;
            } else {
                user_id = currentUser?.id as number;
            }
            await dispatch(removeTimeThunk({
                hour_id,
                user_id,
                date: null,
                month: null
            })).unwrap();
        } catch (e) {
            //
        }
    };

    return <Box>
        <Box display="flex" justifyContent="center" alignItems="center" gap={2} flexWrap="wrap" p={2}>
            {slots.weeklyDay.map((day) => (
                <Box
                    key={day.id}
                    borderRadius={2}
                    p={2}
                    minHeight={200}
                    border="1px solid #e0e0e0"
                    width="22%"
                >
                    <Box display="flex" justifyContent="space-between">
                        <Box display="flex" gap={2}>
                            <IOSSwitch
                                // schedule[day].active
                                checked={day.status === 'active'}
                                onChange={() => handleToggle(day)}
                            />
                            <Typography variant="h6" textTransform="capitalize">{day.day_name}</Typography>
                        </Box>
                        <IconButton size="small" sx={{ display: 'none' }}>
                            <ContentCopy fontSize="small" color="primary" />
                        </IconButton>
                    </Box>

                    {day.status === 'active' &&
                        day.availability_hours.map((time, i) => (
                            <Grid
                                container
                                spacing={1}
                                key={i}
                                alignItems="center"
                                mt={1}
                            >
                                <Grid item xs={day.availability_hours.length > 1 ? 5 : 6}>
                                    <CustomDropdown
                                        value={time.start_time}
                                        onChange={(e) => handleTimeChange(day.id, time, 'from', e.target.value as string)}
                                        options={getFilteredStartTimeOptions(day.availability_hours, time.id)}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 500,
                                                    overflowY: 'auto'
                                                }
                                            }
                                        }}
                                        sx={{ mb: 0 }}
                                    />
                                </Grid>
                                <Grid item xs={day.availability_hours.length > 1 ? 5 : 6}>
                                    <CustomDropdown
                                        value={time.end_time}
                                        onChange={(e) => handleTimeChange(day.id, time, 'to', e.target.value as string)}
                                        options={getFilteredEndTimeOptions(time, day.availability_hours)}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 500,
                                                    overflowY: 'auto'
                                                }
                                            }
                                        }}
                                        sx={{ mb: 0 }}
                                    />
                                </Grid>
                                <Grid item xs={2}>
                                    {day.availability_hours.length > 1 && (
                                        <IconButton onClick={() => removeTimeBlock(time.id)} size="small">
                                            <Delete fontSize="small" color="error" />
                                        </IconButton>
                                    )}
                                </Grid>
                            </Grid>
                        ))}

                    {day.status === 'active' && (
                        <Button
                            onClick={() => addTimeBlock(day.id)}
                            variant="outlined"
                            fullWidth
                            sx={{ mt: 2 }}
                        >
                            + Add time
                        </Button>
                    )}
                </Box>
            ))}
        </Box>
    </Box>;
};

export default WeeklyHoursComponent;